/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/directive-selector */
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Directive,
  QueryList,
} from '@angular/core';

@Directive({
  selector: 'ss-ng-header-title-row1-left',
  host: { class: 'flex items-center justify-center' },
})
export class PageHeaderTitleRow1Left {}

@Directive({
  selector: 'ss-ng-header-content-row1-right',
  host: { class: 'flex md:flex-row gap-1.5 justify-end' },
})
export class PageHeaderContentRow1Right {}

@Directive({
  selector: 'ss-ng-header-content-row2-left',
  host: { class: 'flex md:flex-row gap-1.5' },
})
export class PageHeaderContentRow2Left {}

@Directive({
  selector: 'ss-ng-header-content-row2-right',
  host: { class: 'flex md:flex-row gap-1.5 justify-end' },
})
export class PageHeaderContentRow2Right {}

@Directive({
  selector: 'ss-ng-header-content-row3-left',
  host: { class: 'flex md:flex-row gap-1.5' },
})
export class PageHeaderContentRow3Left {}

@Directive({
  selector: 'ss-ng-header-content-row3-right',
  host: { class: 'flex md:flex-row gap-1.5 justify-end' },
})
export class PageHeaderContentRow3Right {}

@Component({
  selector: 'ss-ng-header',
  templateUrl: './page-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  @ContentChildren(PageHeaderContentRow3Left, { descendants: true })
  row3Left?: QueryList<PageHeaderContentRow3Left>;
  @ContentChildren(PageHeaderContentRow3Right, { descendants: true })
  row3Right?: QueryList<PageHeaderContentRow3Right>;

  get hasRow3() {
    const elements = [
      ...(this.row3Left?.toArray() ?? []),
      ...(this.row3Right?.toArray() ?? []),
    ];
    return elements.length > 0;
  }
}
